export default __webpack_public_path__ + "static/media/logo-chat.72d91c25.svg";